"use client";

import { useContext, useEffect, useRef } from "react";
import { UserContext } from "@/contexts/UserContext";
import { amplitudeTrackUser } from "@/services/AmplitudeService/AmplitudeService";

export const AmplitudeInitializer = () => {
  const userContext = useContext(UserContext);
  const trackedUserId = useRef<string | null>(null);

  const userId = userContext?.user?.userId;

  useEffect(() => {
    if (!userId || trackedUserId.current === userId) return;

    amplitudeTrackUser(userId);
    trackedUserId.current = userId;
  }, [userId]);

  return null;
};
